import { useMemo } from 'react';
import { useCurrentSubscriptionApi } from '../api/use-current-subscription-api';

export function useIsRanOutOfCredit() {
  const { data: subscriptionData } = useCurrentSubscriptionApi();

  return useMemo(() => {
    // we also need to check if enough time has passed since the subscription was created
    // to avoid returning true if the subscription was created just now (for newly signed up users)
    const minutesSinceSubscriptionCreation =
      (Date.now() -
        Date.parse(subscriptionData?.current?.currentPeriodStart ?? '')) /
      (1000 * 60);

    return (
      !subscriptionData?.credit?.total &&
      !!subscriptionData?.current?.currentPeriodStart &&
      minutesSinceSubscriptionCreation > 5 // minutes
    );
  }, [subscriptionData]);
}
